// extracted by mini-css-extract-plugin
module.exports = {"chartBlockTitle":"HarvestForecastHarvestChart_chartBlockTitle__wvPIg","chartWrapper":"HarvestForecastHarvestChart_chartWrapper__8uxrP"};